export default {"src":"/_next/static/media/gm.ed45b5e4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};